import { useRouteCheck } from 'app/components/RouteListCards/RoutesWithoutTaskListCard/hooks/useRouteCheck';
import { selectHiddenOnMapGpsVehicleIds } from 'app/containers/Map/slice/selectors';
import { useGetRoutesWithoutTaskFromState } from 'app/containers/Task/pages/RoutesWithoutTaskPage/hooks/useGetRoutesWithoutTaskFromState';
import { useSelector } from 'react-redux';
import { scrollToElementById } from 'utils/helpers';
import { useRouteFields } from './useRouteFields';

export const useRoutesWithoutTaskMapItems = () => {
  const hiddenGpsVehicleIds = useSelector(selectHiddenOnMapGpsVehicleIds);

  const { routes: allRoutes } = useGetRoutesWithoutTaskFromState();

  // Filter out unchecked transport
  const routes = allRoutes.filter(
    route => !hiddenGpsVehicleIds.includes(route.gpsVehicle.id),
  );

  const { checkedRouteIds, onRoutesCheck, checkedRoutes } = useRouteCheck({
    routes,
  });

  const { routeFields } = useRouteFields({ routes });

  const onFieldClick = ({
    fieldSeasonId,
    routeId,
  }: {
    fieldSeasonId?: number;
    routeId?: number;
  }) => {
    if (!fieldSeasonId) {
      return;
    }
    scrollToElementById(`routeItem${routeId}`);
    if (routeId) {
      onRoutesCheck([routeId]);
    }
  };

  return {
    checkedRoutes,
    onFieldClick,
    checkedRouteIds,
    routeFields,
  };
};
